export type DisplayOddsFormat = 'decimal' | 'hongkong' | 'indo' | 'us' | 'malay';
export const ODDS_FORMAT_LABELS: Record<DisplayOddsFormat, string> = {
  decimal: 'TL Thập phân', hongkong: 'TL HongKong', indo: 'TL Indo', us: 'TL Mỹ', malay: 'TL Malay',
};
export const normalizeDisplayOddsFormat = (value: unknown): DisplayOddsFormat => {
  const key = String(value || '').toLowerCase();
  if (key === 'american') return 'us';
  if (key === 'indonesian') return 'indo';
  return Object.prototype.hasOwnProperty.call(ODDS_FORMAT_LABELS, key) ? key as DisplayOddsFormat : 'decimal';
};
const numeric = (value: unknown): number | null => {
  if (typeof value !== 'number' && typeof value !== 'string') return null;
  if (String(value).trim() === '') return null;
  const number = Number(String(value).replace(',', '.'));
  return Number.isFinite(number) ? number : null;
};
/** Explicit source format is required. Never convert an already rounded display value twice. */
export const oddsToDecimal = (value: unknown, source: DisplayOddsFormat): number | null => {
  const number = numeric(value);
  if (number === null) return null;
  let decimal: number;
  if (source === 'decimal') decimal = number;
  else if (source === 'hongkong') decimal = number > 0 ? 1 + number : NaN;
  else if (source === 'us') decimal = number >= 100 ? 1 + number / 100 : number <= -100 ? 1 + 100 / Math.abs(number) : NaN;
  else decimal = number > 0 ? 1 + number : number < 0 ? 1 + 1 / Math.abs(number) : NaN;
  return Number.isFinite(decimal) && decimal > 1 ? decimal : null;
};
/** All feed markets are decimal; retain the market argument for caller compatibility. */
export const sourceOddsToDecimal = (value: unknown, _market: string): number | null =>
  oddsToDecimal(value, 'decimal');
export const decimalToOdds = (value: unknown, target: DisplayOddsFormat): number | null => {
  const decimal = oddsToDecimal(value, 'decimal');
  if (decimal === null) return null;
  const net = decimal - 1;
  const converted = target === 'decimal' ? decimal : target === 'hongkong' ? net
    : target === 'indo' ? (net >= 1 ? net : -1 / net)
    : target === 'malay' ? (net <= 1 ? net : -1 / net)
    : (net >= 1 ? net * 100 : -100 / net);
  return Number.isFinite(converted) ? converted : null;
};
export const formatDecimalOdds = (value: unknown, target: DisplayOddsFormat): string => {
  const number = decimalToOdds(value, target);
  if (number === null) return '-';
  return target === 'us' ? `${number > 0 ? '+' : ''}${Math.round(number)}` : number.toFixed(2);
};
